import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import IncidentAnalytics from './IncidentAnalytics';
import Sidebar from './Sidebar';
import { AnalyticsV3Container, LeftContainer, RightContainer } from './styles';
import OnCallAnalytics from './OnCallUsersPerHour';

function Layout() {
  const { pathname } = useLocation();
  const renderDashboard = useMemo(() => {
    if (pathname.includes('/on-call-analytics')) return <OnCallAnalytics />;
    else if (pathname.includes('/incident-analytics')) return <IncidentAnalytics />;
  }, [pathname]);

  return (
    <AnalyticsV3Container>
      <LeftContainer>
        <Sidebar currentRoute={pathname} />
      </LeftContainer>
      <RightContainer>{renderDashboard}</RightContainer>
    </AnalyticsV3Container>
  );
}

export default Layout;
